import {
  addUniqueValueToArray
} from 'utils/redux'

export const NAMESPACE = 'KanBo/documentSources/'
export const SET_LOAD_STATUS = NAMESPACE + 'SET_LOAD_STATUS'
export const ADD = NAMESPACE + 'ADD'
export const ADD_ARRAY = NAMESPACE + 'ADD_ARRAY'
export const REMOVE = NAMESPACE + 'REMOVE'
export const SET_DOCUMENT_SOURCE = NAMESPACE + 'SET_DOCUMENT_SOURCE'
export const SET_CURSOR = NAMESPACE + 'SET_CURSOR'

const initialState = {
  documentSources: [],
  documentSourcesById: {},
  cursor: null,
  isLoading: false,
  isLoaded: false
}

const documentDefaults = {
  boards: [],
  isLoaded: false,
  isBusy: false
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case SET_LOAD_STATUS:
      return {
        ...state,
        isLoading: action.payload.isLoading,
        isLoaded: action.payload.isLoaded
      }
    case ADD:
      return {
        ...state,
        documentSources: addUniqueValueToArray({
          array: state.documentSources,
          value: action.payload.id,
          index: action.payload.index
        }),
        documentSourcesById: {
          ...state.documentSourcesById,
          [action.payload.id]: {
            ...documentDefaults,
            ...action.payload
          }
        }
      }
    case ADD_ARRAY: {
      const newState = {
        ...state,
        documentSources: [ ...state.documentSources ],
        documentSourcesById: { ...state.documentSourcesById }
      }
      action.payload.forEach(item => {
        newState.documentSources = addUniqueValueToArray({
          array: newState.documentSources,
          value: item.id,
          index: item.index
        })
        newState.documentSourcesById[item.id] = {
          ...documentDefaults,
          ...item
        }
      })
      return newState
    }
    case REMOVE: {
      const newState = {
        ...state,
        documentSources: [ ...state.documentSources.filter(id => id !== action.payload.id) ],
        documentSourcesById: { ...state.documentSourcesById }
      }
      delete newState.documentSourcesById[action.payload.id]
      return newState
    }
    case SET_DOCUMENT_SOURCE:
      return state.documentSourcesById[action.payload.id] ? {
        ...state,
        documentSourcesById: {
          ...state.documentSourcesById,
          [action.payload.id]: {
            ...state.documentSourcesById[action.payload.id],
            ...action.payload
          }
        }
      } : state
    case SET_CURSOR:
      return {
        ...state,
        cursor: action.payload
      }
    default: return state
  }
}

export function setLoadStatus ({ isLoading, isLoaded }) {
  return {
    type: SET_LOAD_STATUS,
    payload: {
      isLoading,
      isLoaded
    }
  }
}

export function add (data) {
  return {
    type: ADD,
    payload: data
  }
}

export function addArray (boardArray) {
  return {
    type: ADD_ARRAY,
    payload: boardArray
  }
}

export function remove ({ id }) {
  return {
    type: REMOVE,
    payload: {
      id
    }
  }
}

export function setDocumentSource (data) {
  return {
    type: SET_DOCUMENT_SOURCE,
    payload: data
  }
}

export function setCursor (payload) {
  return {
    type: SET_CURSOR,
    payload
  }
}
